<template>
    <div>

    </div>
</template>

<script>
export default {
    name: 'App',

    data() {
        return {

        }
    },
    created() {
        console.log(111)
    },
    mounted() {
        console.log(encodeURIComponent(this.$route.query.token))
        if (encodeURIComponent(this.$route.query.token)) {
            this.$store.commit('token', encodeURIComponent(this.$route.query.token))
            // this.$store.commit('token', this.$route.query.token)
            // this.getMenus()
            // this.getUserInfo()
            this.getToken()
        }
    },
    methods: {
        is_null(content) {
            if (content) {
                return false
            } else {
                return true
            }
        },
        // 获取token
        getToken(n, e) {
            this.axios
                .get('/sys/v1/user/getInfo?winType=1', {
                    headers: {
                        isLoading: false
                    }
                })
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        let array = ''
                        if (this.is_null(res.data.salesAuthorityId)) {
                            array = ''
                        } else {
                            array = res.data.salesAuthorityId
                        }
                        const sess = {
                            parentOrgName: res.data.parentOrgName,
                            orgName: res.data.orgName,
                            reallyName: res.data.reallyName,
                            positionName: res.data.positionName,
                            img: res.data.avatarUrl
                        }
                        this.$store.commit('user_id', res.data.id)
                        sessionStorage.setItem('personInfo', JSON.stringify(sess))
                        sessionStorage.setItem('positionCode', res.data.positionCode)
                        sessionStorage.setItem('orgCode', res.data.orgCode)
                        sessionStorage.setItem(
                            'orgCodes',
                            JSON.stringify(res.data.orgCodes)
                        )
                        sessionStorage.setItem('userInfo', JSON.stringify(res.data))
                        // this.$message({ type: "success", message: "登录成功" });
                        this.limits()
                    } else {
                        this.$message({ type: 'warning', message: res.message })
                    }
                })
        },
        // 权限处理
        limits() {
            this.axios
                .get('/sys/v1/menu/button/user/tree?winType=1', {
                    headers: {
                        isLoading: false
                    }
                })
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        sessionStorage.setItem('limit', JSON.stringify(res.data))
                        if (res.data.menuTreeList) {
                            console.log(res)
                            const juade = res.data.menuTreeList.find(
                                (res) => res.code == 'index'
                            )
                            if (juade) {
                                // this.$router.replace('home')
                                this.$router.replace('home/welcome') // 如果没有配置菜单权限就跳到欢迎页面
                            } else {
                                if (res.data.menuTreeList[0].children) {
                                    this.$router.replace(res.data.menuTreeList[0].children[0].jumpUrl)
                                } else {
                                    this.$router.replace(res.data.menuTreeList[0].jumpUrl)
                                }
                            }
                        } else {
                            this.$message({ type: 'warning', message: res.message })
                        }
                    } else {
                        if (res.code == 103) {
                            this.$router.replace('home/welcome') // 如果没有配置菜单权限就跳到欢迎页面
                        }
                        // this.$message({ type: "warning", message: res.message });
                    }
                })
        },
        //获取菜单列表接口
        getMenus() {
            this.axios.get('/sys/menus')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        let iconList = [
                            'icon_yonghuguanli@2x',
                            'icon_shanpin@2x',
                            'icon_dingdan@2x',
                            'icon_caiwu@2x',
                            'icon_xitong@2x',
                            'icon_shangcheng@2x',
                            'icon_yingxiao@2x'
                        ]
                        // res.data.splice(res.data.length-1,1)
                        res.data.forEach((item, index) => {
                            item.iconUrl = iconList[index]
                        })
                        this.limits(res.data)
                    }

                })
        },
    }
}
</script>

<style></style>